module.exports = __webpack_public_path__ + "static/media/thenovemcloud.f2898ded.svg";